import * as React from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import PdfViewer from "../../utility/PdfViewer";
import PdfViewerModal from "../../utility/PdfViewerModal";
import { handlePdfPreviewScreenOpen } from "../../utility/PdfViewerModal";
import { setSalesForecastSummaryMainElementList } from "../../features/salesForecastSummaryMainElementListSlice";
import "../subPage/SalesForecastSummaryMainElementList/style.css";
import { LOCAL_CONSTANT } from "../Const";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Grid,
    Box,
    Button,
    TableContainer,
    IconButton,
    Typography,
    FormControlLabel,
    Checkbox
} from "@mui/material";
import { useUtilityContext } from "../../utility-provider";
import { getFileMetadata, uploadFile, deleteUploadFile } from "../../utility/storage";
import SelectModal from "../subPage/SalesForecastSummaryMainElementList/SelectModal";
import { postPython } from "../../api/ApiCall";
import MessageDialog from "../components/MessageDialog";
import {
    setLocationBase
} from "../../features/longPageSlice";
import { getLongPageData } from "../../data/DataManage";
import { useUserContext } from "../../user-provider";
import { locationBaseData } from "../components/LocationBaseFunc";
import dayjs from "dayjs";
import { DeleteConfirmationModal } from "../ResearchReport/DeleteConfirmationModal";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import { setPermissionFunc, showHideFunc } from "../components/PermissionFunc";
import { staffName, commonFileDownload, fileExtensionCheck } from "../Common";
import { locationSalesForecastData } from "../components/LocationSalesForecastFunc";
import { setLocationSalesForecastObj } from "../../features/locationSalesForecastSlice";


const templateExcelList = () => {
    return [
        { "template": true, "temp_flag": "1", "recreate": "none", "check_box": false, "label": "【" + LOCAL_CONSTANT.LABEL.TEMPORARY_OUTPUT + "】" + LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE, "uploadDate": "", "uplowder": "", "pdfPath": "" },
        { "template": false, "temp_flag": "0", "recreate": "none", "check_box": true, "label": LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE, "uploadDate": "", "uplowder": "", "pdfPath": "" },
    ]
}

const headerCell = (type: string) => {
    return{
        backgroundColor: "#D9D9D9",
        fontSize: "12px",
        color: "black",
        borderBottom: "1px solid black",
        fontWeight: "Bold",
        width: type === "FILE_NAME" ? "30%"
        : type === "UPLOAD_DATE" ? "15%" 
        : type === "UPLOADER" ? "15%"
        : type === "BUTTON" ? "10%"
        : "6%",
        textAlign: (type === "OTHER"|| type === "BUTTON") ? "center": "start"
    }
};

const salesForecastTableRowStyle = (temp_flag: string) => {
    return{
        backgroundColor: temp_flag === "9" ? "#D9D9D9" : "#fff"
    }
}

export interface salesForecastSummaryMainElementListProps {
    props: {
    }
}

const SalesForecastSummaryMainElementList: React.FC<salesForecastSummaryMainElementListProps> = ({ props }) => {

    const dispatch = useAppDispatch();
    const objflict = useAppSelector((state) => state.salesForecastSummaryMainElementList);
    const handleValueChange = (path: string, labelName: string) => {
        let pdfPath = path

        if(labelName === "pdfPath") {
            if (path) {
                pdfPath = `gs://${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${pdfPath}`
            }
            pdfPath = objflict.pdfPath === pdfPath ? "" : pdfPath
        } else if (labelName === "fiveYearTrendsFilePath") {
            if (path) {
                pdfPath = `gs://${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${pdfPath}`
            }
            pdfPath = objflict.fiveYearTrendsFilePath === pdfPath ? "" : pdfPath
        }
        
        //表示中のPDFレコードを押下時非表示
        dispatch(
            setSalesForecastSummaryMainElementList({
                ...objflict,
                [labelName]: pdfPath,
            })
        );
    }
    const [userType, setUserType] = React.useState("");
    const user = useUserContext();
    //ユーザー取得タイミングによる画面制御
    React.useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);
    //ロングページオブジェクト
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    const objLocationBase = useAppSelector((state) => state.longPage.locationBase);
    const objLSalesForecast = useAppSelector((state) => state.locationSalesForecast);

    const utilityCtx = useUtilityContext();
    const [fiveYearTrendsFile, setFiveYearTrendsFile] = React.useState<File | null>(null);
    const [salesForecasFile, setSalesForecasFile] = React.useState<File | null>(null);
    const [message, setMessage] = React.useState<string>("");
    const [recreate, setRecreate] = React.useState<boolean>(false);
    const [hasButton, setHasButton] = React.useState<boolean>(false);
    const [tempFlag, setTempFlag] = React.useState<string>("1");
    const [editFlag, setEditFlag] = React.useState<boolean>(false);
    const [targetFilePath, setTargetFilePath] = React.useState<string>("");
    const [checkedIndex, setCheckedIndex] = React.useState<number>(1);
    const [salesForecastsColor, setSalesForecastsColor] = React.useState<string>("");
    const [open, setOpen] = React.useState<boolean>(false);
    const [messageDialogOpen, setMessageDialogOpen] = React.useState<boolean>(false);
    const [fiveYearTrendsFileList, setFiveYearTrendsFileList] = React.useState<any[]>([]);
    const [excelList, setExcelList] = React.useState<any[]>([]);
    const [fiveYearTrendsDeleteConfModalOpen, setFiveYearTrendsDeleteConfModalOpen] = React.useState(false);
    const [salesForecastDeleteConfModalOpen, setSalesForecastDeleteConfModalOpen] = React.useState(false);
    // 拡張子エラーかどうかを判別するフラグ
    const [isExtensionError, setIsExtensionError] = React.useState<boolean>(false);
    //モーダル開閉フラグ(PDFプレビュー)
    const [pdfPreviewModalFlag, setPdfPreviewModalFlag] = React.useState(false);
    const [pdfPath, setPdfPath] = React.useState<string>("");

    const handleClickFile = (fileType: string) => {
        let fileElem;
        if(fileType === "fiveYearTrendsFile") {
            fileElem = document.getElementById("fiveYearTrendsFileElem");
        } else if (fileType === "tempSalesForecasFile") {
            setTempFlag("1");
            fileElem = document.getElementById("salesForecasFileElem");
        } else if (fileType === "salesForecasFile") {
            setTempFlag("0");
            fileElem = document.getElementById("salesForecasFileElem");
        }
        if (fileElem) {
            fileElem.click()
        }
    }

    const handleChangeFiveYearTrendsFile = (newFile: any) => {
        // ファイル拡張子チェック（.xlsxと.xlsmのみ許可）
        if (
            fileExtensionCheck(
                newFile.target.files[0],
                LOCAL_CONSTANT.FILE_EXTENSIONS.EXCEL_XLSX_XLSM,
                setMessageDialogOpen,
                setMessage,
                setHasButton,
                LOCAL_CONSTANT.CONFIRM_MESSAGE.EXTENSION_CHECK_XLSX_XLSM
            )
        ) {
            setFiveYearTrendsFile(newFile.target.files[0]);
        } else {
            // 拡張子エラーの場合はフラグを設定
            setIsExtensionError(true);
        }
        newFile.target.value = "";
    };

    const handleChangeSalesForecasFile = (newFile: any) => {
        setSalesForecasFile(newFile.target.files[0]);
        newFile.target.value = "";
    };

    React.useEffect(() => {
        if (fiveYearTrendsFile) {
            fiveYearTrendsFileUpload();
        }
    }, [fiveYearTrendsFile]);

    React.useEffect(() => {
        if (salesForecasFile) {
            setOpen(true)
        }
    }, [salesForecasFile]);

    const handleRecreate = (tempFlag: string, pdfPath: string) => {
        handleValueChange("", "pdfPath");
        setTempFlag(tempFlag);
        setRecreate(true);
        const fileName = pdfPath.split("/").pop()?.replace(/\.pdf$/, "") ?? "";
        setTargetFilePath(fileName);
        setOpen(true);
    }

    React.useEffect(() => {
        if(objLocationBase) {
            setFiveYearTrendsFileList(objLocationBase.trends_file_path);
        }
    }, [objLocationBase]);

    React.useEffect(() => {
        if (objLSalesForecast) {
            setExcelList(templateExcelList);
        }
    }, [objLSalesForecast]);

    React.useEffect(() => {
        if (excelList.length > 0 && objLongPageParam.planAreaId) {
            setExcelList(templateExcelList)
            objLSalesForecast.obj.map((row: any, i:any) => {
                if (row.sales_forecast_pdf_path) {
                    let index = 0
                    let label = "temp_sales_forecast_upload_date"
                    if(row.temp_flag === "1") {
                        excelList[0]["recreate"] = "block"
                        excelList[0]["pdfPath"] = row.sales_forecast_pdf_path
                        excelList[0]["uplowder"] = row.sales_forecast_upload_user
                        index = 0
                        label = "temp_sales_forecast_upload_date"
                    } else if (row.temp_flag === "0") {
                        excelList[1]["recreate"] = "block"
                        excelList[1]["pdfPath"] = row.sales_forecast_pdf_path
                        excelList[1]["uplowder"] = row.sales_forecast_upload_user
                        index = 1
                        label = "sales_forecast_upload_date"
                    } else if (row.temp_flag === "9") {
                        const pushList = { "template": false, "temp_flag": "9", "recreate": "none", "check_box": true, "label": LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE, "uploadDate": row.create_date, "uplowder": row.sales_forecast_upload_user, "pdfPath": row.sales_forecast_pdf_path};
                        excelList.push(pushList);
                        index = excelList.length - 1
                        label = "sales_forecast_upload_date"
                    }
                    getFile(row.sales_forecast_pdf_path, index, label);
                }
            })
            setExcelList(excelList);
        }
    }, [excelList, objLongPageParam]);

    React.useEffect(() => {
        excelList.map((val, index) => {
            if(checkedIndex === index) {
                setTargetFilePath(val.pdfPath);
            }
        })
    }, [checkedIndex]);

    const getFile = (filePath: string, index: number, labelName: string) => {
        (async () => {
            const path = `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${filePath}`
            await getFileMetadata(path)
                .then((fileData: any) => {
                    excelList[index]["uploadDate"] = fileData.updated
                    dispatch(
                        setSalesForecastSummaryMainElementList({
                            ...objflict,
                            [labelName]: fileData.updated,
                        })
                    );
                })
        })();
    }

    const showUploadDate = (param: any) => {
        let date = ""
        if (param) {
            date = dayjs(param).format("YYYY/MM/DD HH:mm:ss")
        }
        return date
    }

    // ファイル名から拡張子を除いた形式で表示する関数
    const showFileName = (val: any) => {
        if (val.pdfPath && val.pdfPath !== "") {
            // PDFパスからファイル名部分を抽出し、拡張子(.pdf)を除去
            const fileName = val.pdfPath.split("/").pop()?.replace(/\.pdf$/, "") ?? "";
            return fileName;
        } else {
            // アップロード前は従来の固定文字列を表示
            return val.label;
        }
    }

    //ファイル保存
    const fileDownload = (filePath: string, fileName: string) => {
        commonFileDownload(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${filePath}`, `${fileName}.pdf`)
    }

    //5年間推移UL処理
    const fiveYearTrendsFileUpload = () => {
        if(fiveYearTrendsFile) {
            const userData = JSON.parse(user.userData);
            const upload_date = dayjs().format("YYYY/MM/DD HH:mm:ss");
            // 元ファイルの拡張子を取得
            const fileExtension = fiveYearTrendsFile.name.substring(fiveYearTrendsFile.name.lastIndexOf('.'));
            // 固定ファイル名 + 拡張子
            const fixedFileName = `5年間推移${fileExtension}`;
            const params = {
                mode: "regist",
                endPoint: "/excel-to-pdf-fiveYearTrends",
                query: {
                    mode: "create",
                    prop_site_no: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                    file_name: fixedFileName,
                    upload_date: upload_date,
                    upload_user_id: userData.staff_number,
                    upload_user_name: staffName(userData.staff_number),
                    location_type: objLocationBase.location_type,
                }
            };
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner();
            }
            (async () => {
                try {
                    setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.CREATE_PDF)
                    setMessageDialogOpen(true)
                    //既存のアップロードファイルを削除
                    let deleteFile = null;
                    fiveYearTrendsFileList.map(async (row: any) => {
                        if (objLocationBase.location_type === row.location_type) {
                            // excel削除
                            deleteFile = await getFileMetadata(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.excel_path}`);
                            await deleteUploadFile(deleteFile, `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.excel_path}`)
                            // pdf削除
                            deleteFile = await getFileMetadata(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`);
                            await deleteUploadFile(deleteFile, `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`)
                        }
                    })
                    await uploadFile(fiveYearTrendsFile, `${objLongPageParam.planAreaId}/${objLongPageParam.branch}/excel/trends/${objLocationBase.location_type}/${fixedFileName}`)
                    await postPython(params)
                    setFiveYearTrendsFile(null)
                    setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.COMPLETE_CREATE_PDF)
                    setHasButton(true)
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                } catch (e) {
                    console.log(e);
                    setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UNCOMPLETE_CREATE_PDF)
                    setHasButton(true)
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                }
            })();
        }
    }

    //売上予測集計表UL処理
    const salesForecasFileUpload = (hasRecreate: boolean) => {
        const userData = JSON.parse(user.userData);
        
        let fileName;
        if (recreate) {
            fileName = `${targetFilePath}.xlsx`;
        } else {
            const dateFormatted = dayjs().format("YYYYMMDD_HHmm");
            if (tempFlag === "1") {
                // 仮予測集計表ファイル命名規則: 【仮予測】予測集計表_枝{枝番}_{候補地ID}_{YYYYMMDD_HHmm}.xlsx
                // 例: 枝番が1、候補地IDがABC123の場合 ⇒ 【仮予測】予測集計表_枝1_ABC123_{YYYYMMDD_HHmm}.xlsx
                fileName = `【仮予測】予測集計表_枝${objLongPageParam.branch}_${objLongPageParam.planAreaId}_${dateFormatted}.xlsx`;
            } else {
                // 予測集計表ファイル命名規則: 予測集計表_枝{枝番}_{候補地ID}_{YYYYMMDD_HHmm}.xlsx
                // 例: 枝番が1、候補地IDがABC123の場合 ⇒ 予測集計表_枝1_ABC123_{YYYYMMDD_HHmm}.xlsx
                fileName = `予測集計表_枝${objLongPageParam.branch}_${objLongPageParam.planAreaId}_${dateFormatted}.xlsx`;
            }
        }
        const params = {
            mode: "regist",
            endPoint: "/excel-to-pdf",
            query: {
                prop_site_no: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                file_name: fileName,
                manager: "",
                color: salesForecastsColor,
                temp_flag: tempFlag,
                isInei: hasRecreate ? "1" : "0",
                mode: recreate ? "recreate" : "create",
                approval_type: "",
                approval_user: userData.user_name,
                approval_department: userData.user_name,
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: userData.user_name
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.CREATE_PDF)
                setMessageDialogOpen(true)
                if (!hasRecreate) {
                    const uploadResult = await uploadFile(salesForecasFile, `${objLongPageParam.planAreaId}/${objLongPageParam.branch}/excel/${fileName}`)
                }
                const result = await postPython(params)
                setSalesForecasFile(null)
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.COMPLETE_CREATE_PDF)
                setHasButton(true)
                setRecreate(false)
                setTargetFilePath("")
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UNCOMPLETE_CREATE_PDF)
                setHasButton(true)
                setRecreate(false)
                setTargetFilePath("")
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }

    const getLocationSalesForecastAndFiveYearTrends = () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        try {
            // API呼び出し
            callApi("getLocationSalesForecastAndFiveYearTrends").then((res: any) => {
                dispatch(setLocationSalesForecastObj(locationSalesForecastData(res.getLocationSalesForecast)));
                dispatch(setLocationBase(locationBaseData(res.getLocationBase)));
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }).catch((e) => {
                console.log(e)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            })
        } catch (e) {
            console.log(e)
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }
    }

    const callApi = async (target: string) => {
        if (target === "getLocationSalesForecastAndFiveYearTrends") {
            // テストデータ固定値
            const param: any = [
                {
                    mode: "getLocationSalesForecast",
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                },
                {
                    mode: "getLocationBase",
                    plan_area_id: objLongPageParam.planAreaId,
                    branch: objLongPageParam.branch,
                }
            ];
            return await getLongPageData(param);
        }
    };

    //PDFプレビューモーダルオープン
    const handlePdfPreviewModalOpen = (pdfPathParam: string) => {
        setPdfPreviewModalFlag(true);
        setPdfPath(pdfPathParam);
    };

    // モダールクローズ後
    const closeMessageDialog = () => {
        setMessage("")
        setHasButton(false)
        setMessageDialogOpen(false)
        
        // 拡張子エラーの場合はAPI呼び出しをスキップ
        if (!isExtensionError) {
            getLocationSalesForecastAndFiveYearTrends()
        }
        setIsExtensionError(false) // フラグをリセット
    }

    //削除確認用モーダル表示 5年間推移
    const handleFiveYearTrendsDeleteConfModalOpen = () => {
        setFiveYearTrendsDeleteConfModalOpen(true);
    };

    //ファイル削除 5年間推移
    const handleFiveYearTrendsDeleteChange = () => {
        handleValueChange("", "fiveYearTrendsFilePath");
        deleteFiveYearTrendsFile();
    };

    const deleteFiveYearTrendsFile = () => {
        const userData = JSON.parse(user.userData)
        const params = {
            mode: "regist",
            endPoint: "/excel-to-pdf-fiveYearTrends",
            query: {
                mode: "delete",
                prop_site_no: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                location_type: objLocationBase.location_type,
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: userData.user_name
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_PDF)
                setMessageDialogOpen(true)
                // ファイル削除
                //既存のアップロードファイルを削除
                let deleteFile = null;
                fiveYearTrendsFileList.map(async (row: any) => {
                    if (objLocationBase.location_type === row.location_type) {
                        // excel削除
                        deleteFile = await getFileMetadata(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.excel_path}`);
                        await deleteUploadFile(deleteFile, `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.excel_path}`)
                        // pdf削除
                        deleteFile = await getFileMetadata(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`);
                        await deleteUploadFile(deleteFile, `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${row.pdf_path}`)
                    }
                })
                await postPython(params)
                setFiveYearTrendsFile(null)
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_PDF)
                setHasButton(true)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_PDF)
                setHasButton(true)
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    //削除確認用モーダル表示  売上予測集計表
    const handleSalesForecastDeleteConfModalOpen = (rowData: any) => {
        setSalesForecastDeleteConfModalOpen(true);
        setTempFlag(rowData.temp_flag); 
        setTargetFilePath(rowData.pdfPath);
    }

    //ファイル削除 売上予測集計表
    const handleSalesForecastDeleteChange = () => {
        handleValueChange("", "pdfPath");
        deleteSalesForecastFile();
    }

    //売上予測集計表　削除
    const deleteSalesForecastFile = () => {
        const userData = JSON.parse(user.userData)
        const params = {
            mode: "regist",
            endPoint: "/excel-to-pdf",
            query: {
                prop_site_no: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                file_name: "",
                manager: "",
                color: salesForecastsColor,
                temp_flag: tempFlag,
                filePath: targetFilePath,
                isInei: "0",
                mode: "delete",
                approval_type: "",
                approval_user: "",
                approval_department: "",
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: userData.user_name
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_PDF)
                setMessageDialogOpen(true)
                // ファイル削除
                let deleteFile = null
                const path = `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}/`
                objLSalesForecast.obj.map(async (row: any) => {
                    if (tempFlag === row.temp_flag && targetFilePath === row.sales_forecast_pdf_path) {
                        // excel削除
                        deleteFile = await getFileMetadata(`${path}${row.sales_forecast_excel_path}`);
                        await deleteUploadFile(deleteFile, `${path}${row.sales_forecast_excel_path}`)
                        // pdf削除
                        deleteFile = await getFileMetadata(`${path}${row.sales_forecast_pdf_path}`);
                        await deleteUploadFile(deleteFile, `${path}${row.sales_forecast_pdf_path}`)
                    }
                })
                await postPython(params)
                setSalesForecasFile(null)
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_PDF)
                setHasButton(true)
                setRecreate(false)
                setTargetFilePath("")
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_PDF)
                setHasButton(true)
                setRecreate(false)
                setTargetFilePath("")
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }

    //対象変更登録処理
    const salesForecastTempFlagFileChange = () => {
        //変更対象のtemp_flagが0の場合処理しない
        let cahngeFlag = true;
        excelList.map((val, index) => {
            if(checkedIndex === index && val.temp_flag === "0") {
                cahngeFlag = false;
            }
        })
        if(!cahngeFlag){
            setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.CONFIRM_CHANGE_PDF);
            setMessageDialogOpen(true);
            setHasButton(true);
            setRecreate(false);
            setEditFlag(false);
            setCheckedIndex(1);
            return
        }
        const userData = JSON.parse(user.userData)
        const params = {
            mode: "regist",
            endPoint: "/excel-to-pdf",
            query: {
                prop_site_no: objLongPageParam.planAreaId,
                branch: objLongPageParam.branch,
                file_name: "",
                manager: "",
                color: salesForecastsColor,
                filePath: targetFilePath,
                isInei: "0",
                mode: "change",
                approval_type: "",
                approval_user: "",
                approval_department: "",
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: userData.user_name
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.CHANGE_PDF);
                setMessageDialogOpen(true);
                await postPython(params);
                setSalesForecasFile(null);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_CHANGE_PDF);
                setHasButton(true);
                setRecreate(false);
                setEditFlag(false);
                setCheckedIndex(1);
                setTargetFilePath("");
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_CHANGE_PDF);
                setHasButton(true);
                setRecreate(false);
                setEditFlag(false);
                setCheckedIndex(1);
                setTargetFilePath("");
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }

    return (
        <Box sx={{ width: "100%", margin: "30px" }}>
            <input
                id="fiveYearTrendsFileElem"
                type="file"
                style={{ display: "none" }}
                onChange={handleChangeFiveYearTrendsFile}
                accept=".xlsx,.xlsm"
            />
            <input
                id="salesForecasFileElem"
                type="file"
                style={{ display: "none" }}
                onChange={handleChangeSalesForecasFile}
                accept=".xlsx"
            />
            {/* 5年間推移 */}
            {(
                objLocationBase.location_type === "02" || 
                objLocationBase.location_type === "03" ||
                objLocationBase.location_type === "04"
            ) && (
                <>
                    <Typography
                        sx={{
                            marginRight: "20px",
                            marginTop: "40px",
                            alignSelf: "flex-start",
                            whiteSpace: "nowrap",
                            fontWeight: "bold",
                        }}
                    >
                        {LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS}
                    </Typography>
                    {showHideFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS, "uploadButton") &&
                        <Box>
                            <Button
                                sx={{ margin: "20px 0" }}
                                variant="contained"
                                color="success"
                                size="small"
                                onClick={(e) => { handleClickFile("fiveYearTrendsFile") }}
                                disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS, "uploadButton")}
                            >{
                                LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS +
                                LOCAL_CONSTANT.LABEL.UPLOAD
                            }</Button>
                        </Box>
                    }
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer sx={{ width: "100%", border: "1px solid black" }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}>Excel</TableCell>
                                            <TableCell sx={headerCell("OTHER")}>PDF</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fiveYearTrendsFileList.map((val, index) => (
                                            <TableRow className="tableRow" key={index}>
                                                {(val.location_type  === objLocationBase.location_type) && (
                                                    <>    
                                                        <TableCell onClick={() => handleValueChange(val.pdf_path, "fiveYearTrendsFilePath")}>{val.file_name}</TableCell>
                                                        <TableCell onClick={() => handleValueChange(val.pdf_path, "fiveYearTrendsFilePath")}>{showUploadDate(val.upload_date)}</TableCell>
                                                        <TableCell onClick={() => handleValueChange(val.pdf_path, "fiveYearTrendsFilePath")}>{staffName(val.upload_user_id)}</TableCell>
                                                        <TableCell sx={{ textAlign: "center" }}>
                                                            {val.pdf_path !== "" && (
                                                                <IconButton
                                                                    sx={{ color: "black" }} 
                                                                    onClick={() =>
                                                                        handlePdfPreviewModalOpen(
                                                                            `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${val.pdf_path}`
                                                                        )
                                                                    }
                                                                >
                                                                    <PictureAsPdfIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: "center" }}>
                                                            {val.pdf_path !== "" && (
                                                                <IconButton
                                                                    sx={{ color: "black" }} 
                                                                    onClick={() =>
                                                                        handlePdfPreviewScreenOpen(
                                                                            `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${val.pdf_path}`
                                                                        )
                                                                    }
                                                                >
                                                                    <OpenInNewIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell  sx={{ textAlign: "center" }}>
                                                            {val.excel_path !== "" && (
                                                                <IconButton 
                                                                    sx={{ color: "black" }} 
                                                                    onClick={() => {
                                                                        // val.excel_pathから拡張子を抽出
                                                                        const extension = "." + val.excel_path.split(".").pop();
                                                                        commonFileDownload(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${val.excel_path}`, `${val.file_name}${extension}`);
                                                                    }}
                                                                    ><DownloadIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell  sx={{ textAlign: "center" }}>
                                                            {val.pdf_path !== "" && (
                                                                <IconButton 
                                                                    sx={{ color: "black" }} 
                                                                    onClick={() => {
                                                                        // val.pdf_pathから拡張子を抽出
                                                                        const extension = "." + val.pdf_path.split(".").pop();
                                                                        commonFileDownload(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${val.pdf_path}`, `${val.file_name}${extension}`);
                                                                    }}
                                                                    ><DownloadIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                        <TableCell  sx={{ textAlign: "center" }}>
                                                            {val.pdf_path !== "" && (
                                                                <IconButton 
                                                                    sx={{ color: "black" }} 
                                                                    onClick={() => handleFiveYearTrendsDeleteConfModalOpen()}
                                                                    disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.FIVE_YEAR_TRENDS, "deleteButton")}
                                                                    ><DeleteIcon />
                                                                </IconButton>
                                                            )}
                                                        </TableCell>
                                                    </>
                                                )}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {objflict.fiveYearTrendsFilePath !== "" &&
                        <Box sx={{ padding: "30px 40px 0px 0px" }}>
                            <PdfViewer props={{ pdfPath: objflict.fiveYearTrendsFilePath }} />
                        </Box>
                    }
                </>
            )}
            {/* 売上予測集計表 */}
            {showHideFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, "tempUploadButton") &&
                <Box>
                    <Button
                        sx={{ margin: "20px 0" }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={(e) => { handleClickFile("tempSalesForecasFile") }}
                        disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, "tempUploadButton")}
                    >{"【" + LOCAL_CONSTANT.LABEL.TEMPORARY_OUTPUT + "】" +
                        LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE +
                        LOCAL_CONSTANT.LABEL.UPLOAD}</Button>
                </Box>
            }
            {showHideFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, "uploadButton") &&
                <Box>
                    <Button
                        sx={{ margin: "20px 0" }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={(e) => { handleClickFile("salesForecasFile") }}
                        disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, "uploadButton")}
                    >{LOCAL_CONSTANT.LABEL.SALES_FORECAST_SUMMARY_TABLE + LOCAL_CONSTANT.LABEL.UPLOAD}</Button>
                </Box>
            }
            <SelectModal
                props={{
                    open: open,
                    handleModal: setOpen,
                    handleRegistColor: setSalesForecastsColor,
                    handleRegistModal: salesForecasFileUpload,
                    recreate: recreate
                }} />
            <MessageDialog props={{
                open: messageDialogOpen,
                handleModal: closeMessageDialog,
                body: message,
                hasButton: hasButton,
                buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
            }}
            />
            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                    <TableContainer sx={{ width: "100%", border: "1px solid black" }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={headerCell("FILE_NAME")}></TableCell>
                                    <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                    <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                    <TableCell sx={headerCell("OTHER")}>{LOCAL_CONSTANT.LABEL.PDF_CREATION}</TableCell>
                                    {editFlag && (<TableCell sx={headerCell("OTHER")}>対象</TableCell>)}
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("BUTTON")}>
                                        {editFlag && (
                                            <Button
                                                sx={{backgroundColor: "#d32f2f"}}
                                                variant="contained"
                                                color="success"
                                                size="small"
                                                onClick={(e) => { setEditFlag(false) }}
                                            >キャンセル</Button>
                                        )}
                                    </TableCell>
                                    <TableCell sx={headerCell("BUTTON")}>
                                        {editFlag ?
                                            (
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="small"
                                                    onClick={(e) => { salesForecastTempFlagFileChange() }}
                                                >保存</Button>
                                            ) : (
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="small"
                                                    onClick={(e) => { setEditFlag(true) }}
                                                    disabled={
                                                        excelList[1]?.pdfPath === "" ? true :
                                                        setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, "editButton")}
                                                >対象選択</Button>
                                            )
                                        }
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {excelList
                                .filter(val => !(userType !== LOCAL_CONSTANT.USER_TYPE.RR && val.temp_flag === "9"))
                                .map((val, index) => (
                                    <TableRow className="tableRow" key={index} sx={salesForecastTableRowStyle(val.temp_flag)}>
                                        <TableCell onClick={() => handleValueChange(val.pdfPath, "pdfPath")}>{showFileName(val)}</TableCell>
                                        <TableCell onClick={() => handleValueChange(val.pdfPath, "pdfPath")}>{showUploadDate(val.uploadDate)}</TableCell>
                                        <TableCell onClick={() => handleValueChange(val.pdfPath, "pdfPath")}>{staffName(val.uplowder)}</TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            {val.recreate == "block" && (
                                                <Button
                                                    variant="contained"
                                                    color="success"
                                                    size="small"
                                                    onClick={(e) => { handleRecreate(val.temp_flag, val.pdfPath) }}
                                                    disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, "recreateButton")}
                                                >{LOCAL_CONSTANT.LABEL.RECREATE}</Button>
                                            )}
                                        </TableCell>
                                        {editFlag && (
                                            <TableCell sx={{ textAlign: "center" }}>
                                                {val.check_box && (
                                                    <FormControlLabel
                                                        sx={{ margin: "0px" }}
                                                        key={index}
                                                        control={
                                                            <Checkbox
                                                                checked={checkedIndex === index}
                                                                onChange={() => setCheckedIndex(index)}
                                                            />
                                                        }
                                                        label={""}
                                                    />
                                                )}
                                            </TableCell>
                                        )}
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.pdfPath !== "" && (
                                                <IconButton
                                                    sx={{ color: "black" }} 
                                                    onClick={() =>
                                                        handlePdfPreviewModalOpen(
                                                            `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${val.pdfPath}`
                                                        )
                                                    }
                                                >
                                                    <PictureAsPdfIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell sx={{ textAlign: "center" }}>
                                            {val.pdfPath !== "" && (
                                                <IconButton
                                                    sx={{ color: "black" }} 
                                                    onClick={() =>
                                                        handlePdfPreviewScreenOpen(
                                                            `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${val.pdfPath}`
                                                        )
                                                    }
                                                >
                                                    <OpenInNewIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            {val.pdfPath !== "" && (
                                                <IconButton 
                                                    sx={{ color: "black" }} 
                                                    onClick={() => fileDownload(val.pdfPath, showFileName(val))}
                                                    ><DownloadIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                        <TableCell  sx={{ textAlign: "center" }}>
                                            {val.pdfPath !== "" && (
                                                <IconButton 
                                                    sx={{ color: "black" }} 
                                                    onClick={() => handleSalesForecastDeleteConfModalOpen(val)}
                                                    disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.SALES_FORECAST_SUMMARY_MAIN_ELEMENT_LIST, "deleteButton")}
                                                    ><DeleteIcon />
                                                </IconButton>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            {objflict.pdfPath !== "" &&
                <Box sx={{ padding: "30px 40px 0px 0px" }}>
                    <PdfViewer props={{ pdfPath: objflict.pdfPath }} />
                </Box>
            }

            {/* 削除確認モーダル 予測集計表 */}
            <DeleteConfirmationModal modalOpen={salesForecastDeleteConfModalOpen} setModalOpen={setSalesForecastDeleteConfModalOpen} deleteMethod={handleSalesForecastDeleteChange} />

            {/* 削除確認モーダル 5年間推移*/}
            <DeleteConfirmationModal modalOpen={fiveYearTrendsDeleteConfModalOpen} setModalOpen={setFiveYearTrendsDeleteConfModalOpen} deleteMethod={handleFiveYearTrendsDeleteChange} />

            {/* PDFプレビューモーダル */}
            <PdfViewerModal
                props={{
                    open: pdfPreviewModalFlag,
                    setOpen: setPdfPreviewModalFlag,
                    pdfPath: pdfPath,
                }}
            />
        
        </Box>
    );

}

export default SalesForecastSummaryMainElementList;
